import { BackgroundColor, CardStyle, Colorways } from 'types/constants';
import { cn } from 'utils/styles';
import { getColorwayName } from 'utils/formatters';

interface CardStyleProps {
  cardStyle: CardStyle;
  color: Colorways;
  index: number;
  total: number;
  className?: string;

  testId?: string;
}

export const getIndicatorColor = (colorway: { name: Colorways } | Colorways): BackgroundColor => {
  const color = getColorwayName(colorway);

  switch (color) {
    case Colorways.Inverse:
      return BackgroundColor.LightGreen;
    default:
      return BackgroundColor.DarkGreen;
  }
};

export function CardStyleIndicator({ cardStyle, color, className, index, total, testId }: CardStyleProps) {
  const internalClassNames = cn(
    'flex-none font-medium text-center',
    { 'inline-flex border border-current self-end rounded-full py-1 px-4 font-sans w-fit': cardStyle === 'Stepped' },
    { 'rounded-md text-heading-sm font-serif w-8 h-8 leading-8 align-middle': cardStyle === 'Paginated' },
    cardStyle === 'Paginated' ? getIndicatorColor(color) : '',
  );

  const testFixture = `${testId ?? 'card'}-style`;

  return ['Stepped', 'Paginated'].includes(cardStyle) ? (
    <div className={cn(internalClassNames, className)} data-testid={`${testFixture}-wrapper`}>
      <span data-testid={`${testFixture}-counter`}>
        {cardStyle === 'Stepped' ? `${index + 1} / ${total}` : index + 1}
      </span>
    </div>
  ) : null;
}
